// extracted by css-extract-rspack-plugin
export default {"table":"k9Rqf","headerCell":"aehbo","footer":"ig3Hy"};